export default "__VITE_ASSET__Bx$LjR86__"